export default __webpack_public_path__ + "static/media/38.cc1eea7e.png";